import Vue from 'vue'
import VueI18n from 'vue-i18n'
// Lib imports

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: {
            'Beers': 'Beers',
            'Draft': 'Draft',
            'Tower': 'Tower',
            'Spirits': 'Spirits',
            'Cocktails': 'Cocktails',
            'Tequila': 'Tequila',
            'Cognac': 'Cognac',
            'Gin': 'Gin',
            'Rum & Anisette': 'Rum & Anisette',
            'Whisky': 'Whisky',
            'Vodka': 'Vodka',
            'Double': 'Double',
            'Stolichnaya': 'Stolichnaya',
            'Absolut': 'Absolut',
            'Grey Goose': 'Grey Goose',
            'Hendriks': 'Hendriks',
            'Bombay': 'Bombay',
            'Gordons': 'Gordons',
            'Jose Cuervo Gold': 'Jose Cuervo Gold',
            'Double Stolichnaya': 'Double Stolichnaya',
            'Double Absolut': 'Double Absolut',
            'Double Grey Goose': 'Double Grey Goose',
            'Double Hendriks': 'Double Hendriks',
            'Double Bombay': 'Double Bombay',
            'Double Gordons': 'Double Gordons',
            'Double Jose Cuervo Gold': 'Double Jose Cuervo Gold',
            'Wine & Bubbly': 'Wine & Bubbly',
            'Red': 'Red',
            'White': 'White',
            'Bubbly': 'Bubbly',
            'Hennessy Class ivm': 'Hennessy Class ivm',
            'Bacardi White': 'Bacardi White',
            'Bacardi Dark': 'Bacardi Dark',
            'Double Bacardi White': 'Double Bacardi White',
            'Double Bacardi Dark': 'Double Bacardi Dark',
            'Captain Morgan Dark': 'Captain Morgan Dark',
            'Captain Morgan Gold': 'Captain Morgan Gold',
            'Double Captain Morgan Dark': 'Double Captain Morgan Dark',
            'Double Captain Morgan Gold': 'Double Captain Morgan Gold',
            'Pastis': 'Pastis',
            'Double Pastis': 'Double Pastis',
            'Sambuca': 'Sambuca',
            'Double Sambuca': 'Double Sambuca',
            'Jim Beam': 'Jim Beam',
            'Double Jim Beam': 'Double Jim Beam',
            'J & B': 'J & B',
            'Double J & B': 'Double J & B',
            'Jameson': 'Jameson',
            'Double Jameson': 'Double Jameson',
            'Jack Daniels': 'Jack Daniels',
            'Double Jack Daniels': 'Double Jack Daniels',
            'Glenfiddich 12 years': 'Glenfiddich 12 years',
            'Macallan 12 Years': 'Macallan 12 Years',
            'Talisker 10 Years': 'Talisker 10 Years',
            'Laphroaig 10 years': 'Laphroaig 10 years',
            'Laphroaig 10 Years': 'Laphroaig 10 Years',
            'Double Glenfiddich 12 years': 'Double Glenfiddich 12 years',
            'Double Macallan 12 Years': 'Double Macallan 12 Years',
            'Double Talisker 10 Years': 'Double Talisker 10 Years',
            'Double Laphroaig 10 years': 'Double Laphroaig 10 years',
            'Others': 'Others',
            'Campari': 'Campari',
            'Kahlua': 'Kahlua',
            'Malibu': 'Malibu',
            'Cointreau': 'Cointreau',
            'Baileys': 'Baileys',
            'Cuba Libre': 'Cuba Libre',
            'Screwdriver': 'Screwdriver',
            'Tequila Sunrise': 'Tequila Sunrise',
            'Baileys Milk': 'Baileys Milk',
            'Green Rabbit': 'Green Rabbit',
            'Snowball': 'Snowball',
            'Irish Carbomb': 'Irish Carbomb',
            'Blue lagoon': 'Blue lagoon',
            'Campari Orange Juice': 'Campari Orange Juice',
            'Cosmopolitan': 'Cosmopolitan',
            'Black Russian': 'Black Russian',
            'White Russian': 'White Russian',
            'Margarita': 'Margarita',
            'Dry Martini': 'Dry Martini',
            'Hendricks': 'Hendricks',
            'Mojito': 'Mojito',
            'Blue All Star': 'Blue All Star',
            'Long Island Iced Tea': 'Long Island Iced Tea',
            'Shots': 'Shots',
            'Shot x 4': 'Shot x 4',
            'Shot x 8': 'Shot x 8',
            'Single Shot - Thursday': 'Single Shot - Thursday',
            'B-52': 'B-52',
            'BJ': 'BJ',
            'Kamikaze': 'Kamikaze',
            'Alien Brain': 'Alien Brain',
            'Jagermeister': 'Jagermeister',
            'Tequila Jose Cueruo Gold': 'Tequila Jose Cueruo Gold',
            'Tequila Jose Cuervo Gold': 'Tequila Jose Cuervo Gold',
            'Soft Drinks': 'Soft Drinks',
            'Lime Juice': 'Lime Juice',
            'Orange Juice (carton)': 'Orange Juice (carton)',
            'Evian Water': 'Evian Water',
            'Perrier': 'Perrier',
            'Nestle 330 ml': 'Nestle 330 ml',
            'Nestle 500ml': 'Nestle 500ml',
            'Fresh Orange Juice': 'Fresh Orange Juice',
            'Fresh Carrot Juice': 'Fresh Carrot Juice',
            'Fresh Cucumber Juice': 'Fresh Cucumber Juice',
            'Fresh Tomato Juice': 'Fresh Tomato Juice',
            'Fresh Orange & Carrot Juice': 'Fresh Orange & Carrot Juice',
            'Black Tea': 'Black Tea',
            'Green Tea': 'Green Tea',
            'Milk Tea': 'Milk Tea',
            'Black Coffee': 'Black Coffee',
            'Makers Mark': 'Makers Mark',
            'Bushmills': 'Bushmills',
            'Martini': 'Martini',
            'Bardinet VSOP': 'Bardinet VSOP',
            'Cider': 'Cider',
            'Apple': 'Apple',
            'Passion Fruit': 'Passion Fruit',
            'Abortion': 'Abortion',
            'Baby Guiness': 'Baby Guiness',
            'Fever Tree Tonic': 'Fever Tree Tonic',
            'Blue Kamikaze': 'Blue Kamikaze',
            'Viking': 'Viking',
            'Cranberry cookie': 'Cranberry cookie',
            'Disaronno': 'Disaronno',
            'Grand Old Parr': 'Grand Old Parr',
            'Canadian Club': 'Canadian Club',
            'Old Virginia': 'Old Virginia',
            'Monkey 47': 'Monkey 47',
            'Pimms': 'Pimms',
            '1800 Reposado': '1800 Reposado',
            '1800 Silver': '1800 Silver',
            'Aperol Sprits': 'Aperol Sprits',
            'Sex On The Beach': 'Sex On The Beach',
            'Singapore Sling': 'Singapore Sling',
            'Moscow Mule': 'Moscow Mule',
            'Negronie': 'Negronie',
            'Caipirinha': 'Caipirinha',
            'Pina Colada': 'Pina Colada',
            'Old fassion': 'Old fassion',
            'Manhattan': 'Manhattan',
            'Cigarettes': 'Cigarettes',
            'Zhong nan hai 5': 'Zhong nan hai 5',
            'Zhong nan hai 8': 'Zhong nan hai 8',
            'Zhong hua': 'Zhong hua',
            'Marlborough Menthol': 'Marlborough Menthol',
            'Double happiness': 'Double happiness',
            'Carlsberg': 'Carlsberg',
            '1664': '1664',
            'Grimbergen': 'Grimbergen',
            'Guinness': 'Guinness',
            'Carlsberg 3L': 'Carlsberg 3L',
            'Brooklyn IPA': 'Brooklyn IPA',
            'Duvel': 'Duvel',
            'Vedett': 'Vedett',
            'Vedett IPA': 'Vedett IPA',
            'Bundaberg (Guava/Ginger)': 'Bundaberg (Guava/Ginger)',
            'TsingTao': 'TsingTao',
            'Budweiser': 'Budweiser',
            'Tiger': 'Tiger',
            'Heineken': 'Heineken',
            'Corona': 'Corona',
            'Delirium Tremens': 'Delirium Tremens',
            'Tripel Karmeliet': 'Tripel Karmeliet',
            'Pech Lindermans': 'Pech Lindermans',
            'Bloody Mary': 'Bloody Mary',
            'Margarira': 'Margarira',
            'Bottle': 'Bottle',
            'Straight': 'Straight',
            'Tonic': 'Tonic',
            'Soda': 'Soda',
            'Coke': 'Coke',
            'Coke Zero': 'Coke Zero',
            'Sprite': 'Sprite',
            'Lemon Juice': 'Lemon Juice',
            'Lime juice': 'Lime juice',
            'Orange Juice': 'Orange Juice',
            'Cranberry Juice': 'Cranberry Juice',
            'Red Bull': 'Red Bull',
            'Red Bull Imported': 'Red Bull Imported',
            'Milk': 'Milk',
            'Imported Red Bull': 'Imported Red Bull',
            'Shot': 'Shot',
            '4 x shot': '4 x shot',
            '8 x shot': '8 x shot',
            'Thursday 1 Shot': 'Thursday 1 Shot',
            'Red Rawsons Retreat Shiraz Cabernet': 'Red Rawsons Retreat Shiraz Cabernet',
            'Rawsons Retreat Shiraz Cabernet': 'Rawsons Retreat Shiraz Cabernet',
            // 'Inycon Cabernet Sauvignon':                         // 'Inycon Cabernet Sauvignon',
            'Red Inycon Cabernet Sauvignon': 'Red Inycon Cabernet Sauvignon',
            'Red La Linda Malbec': 'Red La Linda Malbec',
            'Rive Droite Cotes Du Rhone': 'Rive Droite Cotes Du Rhone',
            'Red Spring Vale Pinot Noir': 'Red Spring Vale Pinot Noir',
            'White Rawsons Retreat Sauvignon Blanc': 'White Rawsons Retreat Sauvignon Blanc',
            'White Marquille Bordeaux': 'White Marquille Bordeaux',
            'White Rive Droit Cotes Du Rhône': 'White Rive Droit Cotes Du Rhône',
            'White Rive Droite Cotes Du Rhone': 'White Rive Droite Cotes Du Rhone',
            'Red Rive Droit Cotes Du Rhône': 'Red Rive Droit Cotes Du Rhône',
            'Red Rive Droite Cotes Du Rhone': 'Red Rive Droite Cotes Du Rhone',
            'Moët & Chandon': 'Moët & Chandon',
            'Prossecco': 'Prossecco',
            'Patron Silver': 'Patron Silver',
            'Jose Cuervo': 'Jose Cuervo',
            'Glass': 'Glass',
            'Glass standard': 'Glass standard',
            'Single': 'Single',
            '4 Shots': '4 Shots',
            '8 Shots': '8 Shots',
            'Thursday Shot': 'Thursday Shot',
            'Cup': 'Cup',
            'Ginger Ale': 'Ginger Ale',
            'With Coke': 'With Coke',
            'Strawberry': 'Strawberry',
            'Pure Blonde': 'Pure Blonde',
            'Hoegaarden (Rose)': 'Hoegaarden (Rose)',
            'Estrella': 'Estrella',
            'Brooklyn Lager': 'Brooklyn Lager',
            'Box': 'Box',
            'End': 'End',
            'All Customers': 'All Customers',
            'Live Order Customers': 'Live Order Customers',
            'Checkout': 'Checkout',
            'Favorite Drinks': 'Favorite Drinks',
            'Orders': 'Orders',
            'TOTAL': 'TOTAL',
            'GO BACK': 'GO BACK',
            'TAB ORDER': 'TAB ORDER',
            'COMPLETE ORDER': 'COMPLETE ORDER',
            'Login Screen': 'Login Screen',
            'Product': 'Product',
            'QTY': 'QTY',
            'PRICE': 'PRICE',
            'Actions': 'Actions',
            'Total': 'Total',
            'Date': 'Date',
            'Staff': 'Staff',
            'Cash': 'Cash',
            'WeChat': 'WeChat',
            'Alipay': 'Alipay',
            'Card': 'Card',
            'Managers Discount': 'Managers Discount',
            'Type': 'Type',
            'Amount': 'Amount',
            'Payment Methods': 'Payment Methods',
            'Coins': 'Coins',
            '1 coin': '1 coin',
            '5 Coins': '5 Coins',
            '10 Coins': '10 Coins',
            'Pool coins': 'Pool coins',
            'Cigarettes & Coins': 'Cigarettes & Coins',
            'Pitcher': 'Pitcher',
            'Deals': 'Deals',
            'Bundaberg (Guava)': 'Bundaberg (Guava)',
            'Bundaberg (Ginger)': 'Bundaberg (Ginger)',
            'Aperol sprits': 'Aperol sprits',
            'Old Fashion': 'Old Fashion',
            'whiskey sour': 'whiskey sour',
            'Free Drinks Remaining': 'Free Drinks Remaining',
            'Brand lemon': 'Brand lemon',
            'Whiskey sour Whiskey sour': 'Whiskey sour Whiskey sour',
            'Whiskey sour': 'Whiskey sour',
            'Fireball': 'Fireball',
            'Hot Chocolate': 'Hot Chocolate',
            'Tia Maria': 'Tia Maria',
            'Double Monkey 47': 'Double Monkey 47',
            // 'Monkey 47':                                         // 'Monkey 47',
            'Lemon juice': 'Lemon juice',
            'Coke zero': 'Coke zero',
            'Double Smirnoff': 'Double Smirnoff',
            'Smirnoff': 'Smirnoff',
            'Double Hennessy Class ivm': 'Double Hennessy Class ivm',
            'Double Glenfiddich 12 Years': 'Double Glenfiddich 12 Years',
            'Double Laphroaig 10 Years': 'Double Laphroaig 10 Years',
            'Double Campari': 'Double Campari',
            'Double Kahlua': 'Double Kahlua',
            'Double Malibu': 'Double Malibu',
            'Double Cointreau': 'Double Cointreau',
            'Double Baileys': 'Double Baileys',
            'Double Makers Mark': 'Double Makers Mark',
            'Double Bushmills': 'Double Bushmills',
            'Double Martini': 'Double Martini',
            'Double Bardinet VSOP': 'Double Bardinet VSOP',
            'Double Disaronno': 'Double Disaronno',
            'Double Grand Old Parr': 'Double Grand Old Parr',
            'Double Canadian Club': 'Double Canadian Club',
            'Double Old Virginia': 'Double Old Virginia',
            'Double Tia Maria': 'Double Tia Maria',

        },
        zh: {
            'Beers': '啤酒',
            'Draft': '生啤',
            'Tower': '塔',
            'Spirits': '烈酒',
            'Cocktails': '鸡尾酒',
            'Tequila': '龙舌兰',
            'Cognac': '白兰地',
            'Gin': '杜松子酒',
            'Rum & Anisette': '朗姆酒和茴香酒',
            'Whisky': '威士忌',
            'Vodka': '伏特加',
            'Double': '双份',
            'Stolichnaya': '苏联红',
            'Absolut': '绝对',
            'Grey Goose': '灰雁',
            'Hendriks': '亨利金',
            'Bombay': '孟买金',
            'Gordons': '哥顿金',
            'Jose Cuervo Gold': '快活金',

            'Double Stolichnaya': '2x苏联红',
            'Double Absolut': '2x绝对',
            'Double Grey Goose': '2x灰雁',
            'Double Hendriks': '2x亨利金',
            'Double Bombay': '2x孟买金',
            'Double Gordons': '2x哥顿金',
            'Double Jose Cuervo Gold': '2x快活金',

            'Wine & Bubbly': '葡萄酒和起泡酒',
            'Red': '干红',
            'White': '干白',
            'Bubbly': '起泡',
            'Hennessy Class ivm': '轩尼诗新点',
            'Bacardi White': '百加得白',
            'Bacardi Dark': '百加得黑',
            'Double Bacardi White': '2x百加得白',
            'Double Bacardi Dark': '2x百加得黑',
            'Captain Morgan Dark': '2x摩根船长黑',
            'Captain Morgan Gold': '2x摩根船长金',
            'Double Captain Morgan Dark': '2x摩根船长黑',
            'Double Captain Morgan Gold': '2x摩根船长金',
            'Pastis': '茴香酒',
            'Double Pastis': '2x茴香酒',
            'Sambuca': '森伯加',
            'Double Sambuca': '2x森伯加',
            'Jim Beam': '占边',
            'Double Jim Beam': '2x占边',
            'J & B': '珍宝',
            'Double J & B': '2x珍宝',
            'Jameson': '占美神',
            'Double Jameson': '2x占美神',
            'Jack Daniels': '杰克丹尼',
            'Double Jack Daniels': '2x杰克丹尼',
            'Glenfiddich 12 years': '格兰菲迪12年',
            'Macallan 12 Years': '麦卡伦12年',
            'Talisker 10 Years': '泰斯卡10年',
            'Laphroaig 10 years': '拉弗格10年',
            'Laphroaig 10 Years': '拉弗格10年',
            'Double Glenfiddich 12 years': '2x格兰菲迪12年',
            'Double Macallan 12 Years': '2x麦卡伦12年',
            'Double Talisker 10 Years': '2x泰斯卡10年',
            'Double Laphroaig 10 years': '2x拉弗格10年',
            'Others': '其他',
            'Campari': '金巴利',
            'Kahlua': '甘露咖啡酒',
            'Malibu': '马利宝椰子酒',
            'Cointreau': '君度',
            'Baileys': '百利甜酒',
            'Cuba Libre': '自由古巴',
            'Screwdriver': '螺丝刀',
            'Tequila Sunrise': '龙舌兰日出',
            'Baileys Milk': '百利甜酒牛奶',
            'Green Rabbit': '绿色兔子',
            'Snowball': '雪球',
            'Irish Carbomb': '爱尔兰深水炸弹',
            'Blue lagoon': '蓝色之湖',
            'Campari Orange Juice': '金巴利橙汁',
            'Cosmopolitan': '大都会',
            'Black Russian': '黑俄罗斯',
            'White Russian': '白俄罗斯',
            'Margarita': '玛格丽特',
            'Dry Martini': '马天尼',
            'Hendricks': '亨利金',
            'Mojito': '莫吉托',
            'Blue All Star': '蓝色满天星',
            'Long Island Iced Tea': '长岛冰茶',
            'Shots': '短饮',
            'Shot x 4': '短饮×4',
            'Shot x 8': '短饮×8',
            'Single Shot - Thursday': '周四短饮',
            'B-52': 'B-52',
            'BJ': 'BJ',
            'Kamikaze': '神风敢死队',
            'Alien Brain': '外星人脑',
            'Jagermeister': '野格酒',
            'Tequila Jose Cueruo Gold': '金快活龙舌兰',
            'Tequila Jose Cuervo Gold': '金快活龙舌兰',
            'Soft Drinks': '软饮料',
            'Lime Juice': '青柠汁',
            'Orange Juice (carton)': '橙汁',
            'Evian Water': '依云水',
            'Perrier': '巴黎水',
            'Nestle 330 ml': '雀巢330毫升',
            'Nestle 500ml': '雀巢500毫升',
            'Fresh Orange Juice': '鲜榨橙汁',
            'Fresh Carrot Juice': '鲜榨胡萝卜汁',
            'Fresh Cucumber Juice': '鲜榨黄瓜汁',
            'Fresh Tomato Juice': '鲜炸番茄汁',
            'Fresh Orange & Carrot Juice': '鲜榨橙及胡萝卜汁',
            'Black Tea': '红茶',
            'Green Tea': '绿茶',
            'Milk Tea': '奶茶',
            'Black Coffee': '黑咖啡',
            'Makers Mark': '美格威士忌',
            'Bushmills': '布什米尔斯',
            'Martini': '马天尼鸡尾酒',
            'Bardinet VSOP': 'Bardinet VSOP',
            'Cider': '苹果酒',
            'Apple': '苹果原味',
            'Passion Fruit': '百香果',
            'Abortion': '流惨',
            'Baby Guiness': '宝贝健力士',
            'Fever Tree Tonic': '纷味汤力水',
            'Blue Kamikaze': '蓝神风',
            'Viking': '海盗',
            'Cranberry cookie': '蔓越莓酷基',
            'Disaronno': '帝萨诺娜',
            'Grand Old Parr': '老伯威',
            'Canadian Club': '加拿大俱乐部',
            'Old Virginia': '老维珍6年',
            'Monkey 47': '猴子王',
            'Pimms': '绿草',
            '1800 Reposado': '1800 典藏',
            '1800 Silver': '1800银',
            'Aperol Sprits': '阿佩罗鸡酒',
            'Sex On The Beach': '性感沙滩',
            'Singapore Sling': '新加坡司令',
            'Moscow Mule': '莫斯科骡子',
            'Negronie': '那格罗尼',
            'Caipirinha': '凯匹林纳鸡尾酒',
            'Pina Colada': '椰林飘香',
            'Old fassion': '古典',
            'Manhattan': '曼哈顿',
            'Cigarettes': '香烟',
            'Zhong nan hai 5': '中南海5',
            'Zhong nan hai 8': '中南海8',
            'Zhong hua': '中华',
            'Marlborough Menthol': '万宝路薄荷',
            'Double happiness': '红双喜',
            'Carlsberg': '嘉士伯',
            '1664': '1664',
            'Grimbergen': '格林堡',
            'Guinness': '健力士',
            'Carlsberg 3L': '嘉士伯3L',
            'Brooklyn IPA': '布鲁克林IPA',
            'Duvel': '杜威',
            'Vedett': '白熊',
            'Vedett IPA': '白熊 IPA',
            'Bundaberg (Guava/Ginger)': '宾得宝（番石榴/干姜）',
            'TsingTao': '青岛啤酒',
            'Budweiser': '百威',
            'Tiger': '虎牌',
            'Heineken': '喜力',
            'Corona': '科罗纳',
            'Delirium Tremens': '粉象',
            'Tripel Karmeliet': '卡美里特',
            'Pech Lindermans': '林德曼桃子',
            'Bloody Mary': '血腥玛丽',
            'Margarira': '玛格丽特',
            'Bottle': '瓶装',
            'Straight': '纯饮',
            'Tonic': '汤力水',
            'Soda': '苏打',
            'Coke': '可乐',
            'Coke Zero': '零度可乐',
            'Sprite': '雪碧',
            'Lemon Juice': '柠檬汁',
            'Lime juice': '青柠汁',
            'Orange Juice': '橙汁',
            'Cranberry Juice': '蔓越莓汁',
            'Red Bull': '红牛',
            'Red Bull Imported': '红牛进口',
            'Milk': '牛奶',
            'Imported Red Bull': '进口红牛',
            'Shot': '短饮',
            '4 x shot': '短饮x4',
            '8 x shot': '短饮×8',
            'Thursday 1 Shot': '周四短饮',
            'Red Rawsons Retreat Shiraz Cabernet': 'Rawsons洛神山庄设拉子赤霞珠干红',
            'Rawsons Retreat Shiraz Cabernet': 'Rawsons洛神山庄设拉子赤霞珠干红',
            // 'Inycon Cabernet Sauvignon': '太阳谷葡园精选系列赤霞珠干红',
            'Red Inycon Cabernet Sauvignon': '太阳谷葡园精选系列赤霞珠干红',
            'Red La Linda Malbec': '琳达·马尔贝干红',
            'Rive Droite Cotes Du Rhone': '丽芙罗纳河谷干红',
            'Red Spring Vale Pinot Noir': '春谷梅尔罗斯干红',
            'White Rawsons Retreat Sauvignon Blanc': '洛神山庄赛美容长相思白葡萄酒',
            'White Marquille Bordeaux': '玛琪尔干白',
            'White Rive Droit Cotes Du Rhône': '丽芙罗纳河谷干白',
            'White Rive Droite Cotes Du Rhone': '丽芙罗纳河谷干白',
            'Red Rive Droit Cotes Du Rhône': '丽芙罗纳河谷干红',
            'Red Rive Droite Cotes Du Rhone': '丽芙罗纳河谷干红',
            'Moët & Chandon': '酩悦',
            'Prossecco': '普洛塞克起泡酒',
            'Patron Silver': '白恩银',
            'Jose Cuervo': '金快活',
            'Glass': '杯',
            'Glass standard': '标准杯',
            'Single': '单份',
            '4 Shots': '4杯短饮',
            '8 Shots': '8个短饮',
            'Thursday Shot': '周四短饮',
            'Cup': '杯',
            'Ginger Ale': '干姜水',
            'With Coke': '加可乐',
            'Strawberry': '草莓',
            'Pure Blonde': '金发女郎',
            'Hoegaarden (Rose)': '福佳（玫瑰）',
            'Estrella': '星达露',
            'Brooklyn Lager': '布鲁克林拉格',
            'Box': '箱',

            'End': '结束',
            'All Customers': '所有顾客',
            'Live Order Customers': '实时订单客户',
            'Checkout': '查看',
            'Favorite Drinks': '最喜欢的饮料',
            'Orders': '命令',
            'TOTAL': '总',
            'GO BACK': '回去',
            'TAB ORDER': '欠单',
            'COMPLETE ORDER': '完成订单',
            'Login Screen': '登入画面',

            'Product': '产品',
            'QTY': '数量',
            'PRICE': '单价',
            'Actions': '编辑',
            'Total': '合计',
            'Date': '日期',
            'Staff': '员工',
            'Cash': '现金',
            'WeChat': '微信',
            'Alipay': '支付宝',
            'Card': '刷卡',
            'Managers Discount': '经理折扣',
            'Type': '方式',
            'Amount': '金额',
            'Payment Methods': '支付方式',
            'Coins': '硬币',
            '1 coin': '1个硬币',
            '5 Coins': '5个硬币',
            '10 Coins': '10个硬币',
            'Pool coins': '个硬币',
            'Cigarettes & Coins': '香烟和硬币',
            'Pitcher': '扎',
            'Deals': '特价',
            'Bundaberg (Guava)': '宾得宝番石榴',
            'Bundaberg (Ginger)': '宾得宝干姜',
            'Aperol sprits': '阿佩罗基酒',
            'Old Fashion': '古典',
            'whiskey sour': '威士忌酸',
            'Free Drinks Remaining': '送的饮料',
            'Brand lemon': '柠檬低醇',
            'Whiskey sour Whiskey sour': '威士忌酸',
            'Whiskey sour': '威士忌酸',
            'Fireball': '火龙',
            'Hot Chocolate': '热巧克力',
            'Tia Maria': '添万利',
            'Double Monkey 47': '2x猴子王金酒',
            // 'Monkey 47': '猴子王金酒',
            'Lemon juice': '柠檬汁',
            'Coke zero': '零度可乐',

            'Double Smirnoff': '2x斯米诺',
            'Smirnoff': '斯米诺',
            'Double Hennessy Class ivm': '2x轩尼诗新点',
            'Double Glenfiddich 12 Years': '2x格兰菲迪12年',
            'Double Laphroaig 10 Years': '2x拉夫格',
            'Double Campari': '2x金巴利',
            'Double Kahlua': '2x咖啡甜酒',
            'Double Malibu': '2x马利宝椰子酒',
            'Double Cointreau': '2x君度',
            'Double Baileys': '2x百利甜酒',
            'Double Makers Mark': '2x美格波本',
            'Double Bushmills': '2x布什米尔',
            'Double Martini': '2x马天尼',
            'Double Bardinet VSOP': '2xVSOP',
            'Double Disaronno': '2x蒂萨诺娜',
            'Double Grand Old Parr': '2x老伯威',
            'Double Canadian Club': '2x加拿大俱乐部',
            'Double Old Virginia': '2x老维珍',
            'Double Tia Maria': '2x添万利',

        }
    }
});

export default i18n
